// theme constant

export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
// export const socket = io(process.env.REACT_APP_SOCKET);